import React from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_MIQAATS } from "./gql/queries";
import Nav from "../../components/Nav";
import Auth from "../../utils/auth";
import { Navigate } from "react-router-dom";
import CreateMiqaat from "./components/CreateMiqaat";
import UserMiqaat from "./components/UserMiqaat";
import MiqaatCard from "./components/MiqaatCard";
import { useMediaQuery } from "../../utils/deviceChecker";
import AddToCalendar from "../../components/AddToCalendar/AddToCalendar";

const Miqaat = () => {

    const { data: miqaatData } = useQuery(GET_ALL_MIQAATS);
    let miqaats = miqaatData?.miqaats || [];
    const isDesktop = useMediaQuery("(min-width: 1258px)");

    return (
        <>
            <div className="navAndHeader">
                <Nav />
            </div>

            <div className="mainContainer">
                <h1>Miqaats <AddToCalendar calendarKey="miqaats" /></h1>
                <div className="miqaatContainer">
                    {miqaats && miqaats.map((miqaat) => (
                        <MiqaatCard miqaat={miqaat} />
                    ))}
                </div>
                <UserMiqaat />
                {Auth.isMiqaatAdmin() && Auth.isFmbAdmin() && isDesktop && <CreateMiqaat />}
            </div>
        </>
    )
};

export default Miqaat;
